import actions from './constants';

export const updateCurrentSearchPermissions = (code, permissions) => ({
  type: actions.UPDATE_CURRENT_SEARCH_PERMISSIONS,
  code,
  permissions,
});

export const fetchSearchMembers = (category, code, assignable, filter) => ({
  type: actions.FETCH_SEARCH_MEMBERS,
  category,
  code,
  assignable,
  filter,
});

export const updateSearchMemberProperties = (category, code, assignable, properties) => ({
  type: actions.UPDATE_SEARCH_MEMBER_PROPERTIES,
  category,
  code,
  assignable,
  properties,
});

export const showShareSearch = (category, code) => ({
  type: actions.SHOW_SHARE_SEARCH,
  category,
  code,
});

export const hideShareSearch = (category, code) => ({
  type: actions.HIDE_SHARE_SEARCH,
  category,
  code,
});

export const showSearchMembers = (category, code, results, resultsCount, assignable) => ({
  type: actions.SHOW_SEARCH_MEMBERS,
  category,
  code,
  results,
  resultsCount,
  assignable,
});

export const showSearchMembersError = (category, code, error, assignable) => ({
  type: actions.SHOW_SEARCH_MEMBERS_ERROR,
  category,
  code,
  error,
  assignable,
});

export const updateShareSearchProperties = (properties) => ({
  type: actions.UPDATE_SHARE_SEARCH_PROPERTIES,
  properties,
});

export const addSearchMembers = (category, code) => ({
  type: actions.ADD_SEARCH_MEMBERS,
  category,
  code,
});

export const removeSearchMember = (category, code, memberID) => ({
  type: actions.REMOVE_SEARCH_MEMBER,
  category,
  code,
  memberID,
});

export const updateSearchMemberPermissions = (category, code, memberID, permissions) => ({
  type: actions.UPDATE_SEARCH_MEMBER_PERMISSIONS,
  category,
  code,
  memberID,
  permissions,
});

export const shareSearch = () => ({
  type: actions.SHARE_SEARCH,
});

export const shareSearchSuccess = (code, name, members, destroy) => ({
  type: actions.SHARE_SEARCH_SUCCESS, code, name, members, destroy,
});

export const shareSearchError = (code, name, members) => ({
  type: actions.SHARE_SEARCH_ERROR,
  code,
  name,
  members,
});
